



import { default as Component } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import DatePicker from '@/components/vuejs-datepicker/src/components/Datepicker.vue';
import MessagesBlock from '@/components/snippets/messages/MessagesBlock.vue';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import Api from '@/interfaces/Api';
import { AxiosResponse } from 'axios';
import Basic from './Basic.vue';
import NonCommodityRegistrationUpload from '@/models/NonCommodityRegistrationUpload';
import FileService from '@/Services/FileService';
import NonCommodityBase from './NonCommodityBase.vue';
import convert from 'heic-convert';

const ApiProvider = IocContainer.get<Api>(SERVICES.API);

@Component({
  props: {
    minimumAgeRequired: Number
  },
  components: {
    'date-picker': DatePicker,
    'messages-block': MessagesBlock
  }
})
export default class NonCommodityRegistrationWidget extends NonCommodityBase {
  @Prop() public extendedDataParentKey!: string;

  public isSubmitting: boolean = false;

  public registrationFileFront: NonCommodityRegistrationUpload = NonCommodityRegistrationUpload.withData({
    side: 'front'
  });

  public registrationFileBack: NonCommodityRegistrationUpload = NonCommodityRegistrationUpload.withData({
    side: 'back'
  });

  public get isStepComplete(): boolean {
    if (window.Cypress) {
      return true;
    }
    return this.registrationFileFront.isUploaded && this.registrationFileBack.isUploaded;
  }

  beforeMount(): void {
    this.loadGenericData();
  }

  protected loadGenericData(): void {
    this.registrationFileFront.loadPreviewFromGenericData();
    this.registrationFileBack.loadPreviewFromGenericData();
  }

  protected checkFileType(file: File, registrationFile: NonCommodityRegistrationUpload): void {
    const supportedFileTypes: string[] = ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'];

    if (!supportedFileTypes.includes(file.type)) {
      registrationFile.isUploading = false;
      registrationFile.fileTypeError = true;
    }
  }

  public onFileSelect(event: Record<any, any>): boolean {
    const side: string = event.target.getAttribute('data-side');
    const registrationFile: NonCommodityRegistrationUpload =
      side == 'front' ? this.registrationFileFront : this.registrationFileBack;

    if (registrationFile.isUploading) {
      return false;
    }
    registrationFile.reset().isUploading = true;

    const file: File = event.target.files[0];

    if (file.type == 'image/heic') {
      file.arrayBuffer().then((buffer) => {
        convert({
          buffer: new Uint8Array(buffer),
          format: 'JPEG'
        }).then((result) => {
          const convertedFile = new File([result], file.name, { type: 'image/jpeg' });
          this.uploadFile(registrationFile, side, convertedFile);
        });
      });

      return true;
    }

    this.checkFileType(file, registrationFile);

    if (registrationFile.fileTypeError) {
      return false;
    }

    this.uploadFile(registrationFile, side, file);

    return true;
  }

  public uploadFile(registrationFile, side, file) {
    const fileService = new FileService(side, file);

    fileService
      .upload()
      .then((res): void => {
        if (res.status === 200) {
          registrationFile.isUploading = false;
          registrationFile.isUploaded = true;
          registrationFile.isPdf = file.type == 'application/pdf';
          fileService.getPreview().then((preview) => {
            registrationFile.previewUrl = preview;
          });
        } else {
          throw res;
        }
      })
      .catch((err) => {
        if (side == 'front') {
          this.registrationFileFront.reset();
          this.handleUploadError(err, this.registrationFileFront);
        } else {
          this.registrationFileBack.reset();
          this.handleUploadError(err, this.registrationFileBack);
        }
      });
  }

  protected handleUploadError(err, side): void {
    if (err.message) {
      if (err.message === 'FileTooBig') {
        side.sizeError = true;
      }
    }
  }

  public registrationSubmit(): void {
    if (this.isStepComplete) {
      this.isSubmitting = true;
      const data = {
        extendedData: this.extendedData
      };
      ApiProvider.sessionUpdate(data)
        .then((response: AxiosResponse) => {
          this.store.commit('SET_SESSION', {
            extendedData: this.extendedData
          });
          this.$emit('registrationSubmit');
          this.isSubmitting = false;
        })
        .catch((err) => {
          console.warn('@to do: Display error message');
          console.warn(err);
          this.isSubmitting = false;
        });
    }
  }
}
